import React from 'react';
import s from './PageTitle.scss';

const VIEWPORT_PADDING = 220;
const MIN_ELLIPSIS_WIDTH = 250;

const probeStyle: React.CSSProperties = {
  position: 'fixed',
  visibility: 'hidden',
};

export const useTitleEllipsisMaxWidth = (probeText: string) => {
  const probeEl = React.useRef<HTMLSpanElement | null>(null);
  const [maxWidth, setMaxWidth] = React.useState<number | undefined>(undefined);

  const measure = React.useCallback(() => {
    if (!probeEl.current?.textContent) {
      return;
    }
    const probeWidth = probeEl.current.getBoundingClientRect().width;
    setMaxWidth(
      Math.max(
        window.innerWidth - probeWidth - VIEWPORT_PADDING,
        MIN_ELLIPSIS_WIDTH,
      ),
    );
  }, []);

  const probeRef = React.useCallback(
    (el: HTMLSpanElement | null) => {
      probeEl.current = el;
      if (el) {
        measure();
      }
    },
    [measure],
  );

  React.useEffect(() => {
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [measure]);

  const probe = (
    <span
      ref={probeRef}
      aria-hidden="true"
      className={s.title}
      style={probeStyle}
    >
      {probeText}
    </span>
  );

  return { maxWidth, probe };
};
